// @flow
import * as React from 'react';
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { ListItem } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import { Trans, useTranslation } from "react-i18next";
import { EXHIBITOR_PROFILE } from "../../../locales/components/namespaces";
import { CatalogueLanguages } from "../../../helpers/constants";
import SquareIcon from '@mui/icons-material/Square';

type Props = {};

const CatalogueExample = (props: Props) => {
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	const { catalogueLanguage } = props
	return (
		<Box sx={{ width: '100%' }}>
			<Typography variant="body" fontWeight={700} sx={{ color: 'text.main' }}>
				{t('Catalogue Example')}
			</Typography>
			<List sx={{ p: 0, pl: 1 }}>
				<ListItem
					disablePadding
					sx={{ alignItems: 'center', p: 0 }}
				>
					<ListItemIcon sx={{
						minWidth: '15px'
					}}>
						<SquareIcon
							sx={{
								color: 'text.main',
								fontSize: '6px'
							}}
						/>
					</ListItemIcon>
					<ListItemText
						sx={{
							fontSize: '1rem',
							lineHeight: '1.5rem'
						}}
					>
						<strong
							style={{
								fontSize: '1rem',
								lineHeight: '1.5rem',
								color: 'text.main'
							}}
						>{t('COMPANY NAME')}{catalogueLanguage === CatalogueLanguages.EN ? t(' (IN CAPITAL LATIN LETTERS)') : ''}</strong>: <em
						style={{
							fontSize: '1rem',
							lineHeight: '1.5rem',
							color: 'text.main',
						}}
					>ROTA SA</em>
					</ListItemText>
				</ListItem>
				<ListItem
					disablePadding
					sx={{ alignItems: 'center' }}
				>
					<ListItemIcon sx={{
						minWidth: '15px'
					}}>
						<SquareIcon
							sx={{
								color: 'text.main',
								fontSize: '6px'
							}}
						/>
					</ListItemIcon>
					<ListItemText>
						<strong
							style={{
								fontSize: '1rem',
								lineHeight: '1.5rem',
								color: 'text.main'
							}}
						>{t('Address')}</strong>: <em
						style={{
							fontSize: '1rem',
							lineHeight: '1.5rem',
							color: 'text.main'
						}}
					>{t('rota_address')}</em>
					</ListItemText>
				</ListItem>
				<ListItem
					disablePadding
					sx={{ alignItems: 'center' }}
				>
					<ListItemIcon sx={{
						minWidth: '15px'
					}}>
						<SquareIcon
							sx={{
								color: 'text.main',
								fontSize: '6px'
							}}
						/>
					</ListItemIcon>
					<ListItemText>
						<strong
							style={{
								fontSize: '1rem',
								lineHeight: '1.5rem',
								color: 'text.main'
							}}
						>{t('Tel.')}</strong>: <em
						style={{
							fontSize: '1rem',
							lineHeight: '1.5rem',
							color: 'text.main'
						}}
					>2111801801, 2111801802</em>
					</ListItemText>
				</ListItem>
				<ListItem
					disablePadding
					sx={{ alignItems: 'center' }}
				>
					<ListItemIcon sx={{
						minWidth: '15px'
					}}>
						<SquareIcon
							sx={{
								color: 'text.main',
								fontSize: '6px'
							}}
						/>
					</ListItemIcon>
					<ListItemText>
						<strong
							style={{
								fontSize: '1rem',
								lineHeight: '1.5rem',
								color: 'text.main'
							}}
						>e-mail</strong>: <em
						style={{
							fontSize: '1rem',
							lineHeight: '1.5rem',
							color: 'text.main'
						}}
					>support@rota.gr</em>
					</ListItemText>
				</ListItem>
				<ListItem
					disablePadding
					sx={{ alignItems: 'center' }}
				>
					<ListItemIcon sx={{
						minWidth: '15px'
					}}>
						<SquareIcon
							sx={{
								color: 'text.main',
								fontSize: '6px'
							}}
						/>
					</ListItemIcon>
					<ListItemText>
						<strong
							style={{
								fontSize: '1rem',
								lineHeight: '1.5rem',
								color: 'text.main'
							}}
						>{t('Website')}</strong>: <em
						style={{
							fontSize: '1rem',
							lineHeight: '1.5rem',
							color: 'text.main'
						}}
					>www.rota.gr</em>
					</ListItemText>
				</ListItem>
				<ListItem
					disablePadding
					sx={{ alignItems: 'center' }}
				>
					<ListItemIcon sx={{
						minWidth: '15px'
					}}>
						<SquareIcon
							sx={{
								color: 'text.main',
								fontSize: '6px'
							}}
						/>
					</ListItemIcon>
					<ListItemText>
						<strong
							style={{
								fontSize: '1rem',
								lineHeight: '1.5rem',
								color: 'text.main'
							}}
						>{t('COMPANY PROFILE (Up to 350 characters)')}</strong>:
						<Trans
							i18nKey={'catalog_example'}
							ns={EXHIBITOR_PROFILE}
							components={{
								bold: <strong/>, em: <em style={{
									fontSize: '1rem',
									lineHeight: '1.5rem',
									color: 'text.main'
								}}/>
							}}
						/>
					</ListItemText>
				</ListItem>
			</List>
		</Box>
	);
};

export default CatalogueExample